import createReactComponent from '../createReactComponent';
export default createReactComponent('walk', 'IconWalk', [
  ['path', { d: 'M13 4m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0', key: 'svg-0' }],
  ['path', { d: 'M7 21l3 -4', key: 'svg-1' }],
  ['path', { d: 'M16 21l-2 -4l-3 -3l1 -6', key: 'svg-2' }],
  ['path', { d: 'M6 12l2 -3l4 -1l3 3l3 1', key: 'svg-3' }],
]);
